import React from 'react';
import SectionCounter from './SectionCounter';

/**
 * Barra de cabecera de una sección: título, recuento y acciones.
 *
 * La forma es la de Entradas, que es la que el diseño da por buena — tarjeta de
 * radio 8 con borde `border` sobre `card`, SIN sombra, título de 24 semibold en
 * `foreground`, y las acciones a la derecha.
 *
 * Había al menos tres versiones. `ButtonBar` (diez secciones) pintaba
 * `rounded-lg shadow border-gray-200` con el título en `text-gray-800`; Socios,
 * `rounded-2xl shadow-sm` con `text-gray-900`; Entradas, la correcta. A ojo se
 * notaba sobre todo en la sombra y en el radio, que cambiaban de una sección a
 * otra sin motivo.
 *
 * `sticky` por defecto: en tablet la acción principal —«Nueva entrada», «Nueva
 * caja»— tiene que seguir a la vista al bajar por una lista larga.
 */
export default function SectionHeader({
  title,
  /** Una línea bajo el título, para las secciones que explican qué se hace aquí. */
  subtitle,
  count,
  countTone,
  children,
  sticky = true,
  className = '',
  /** Para las barras cuyos controles ocupan la fila entera (Socios: el buscador crece). */
  actionsClassName = 'w-full min-w-0 flex-col sm:flex-row sm:items-center lg:w-auto',
}) {
  return (
    <div
      data-testid="section-header"
      className={
        `${sticky ? 'sticky top-0 z-30 ' : ''}` +
        'flex flex-col gap-3 rounded-md border border-[var(--border)] bg-[var(--card)] p-4 ' +
        `lg:flex-row lg:items-center lg:justify-between ${className}`
      }
    >
      <div className="flex min-w-0 flex-col gap-1">
        <div className="flex min-w-0 items-center gap-3">
          {/* Sin truncate: un título cortado es información perdida (reporte iPad
              05-09, «Carritos pendientes» a 1024 px). Si la fila no cabe, el
              título ENVUELVE y la barra crece; quien cede ancho es la zona de
              acciones (min-w-0 en el consumidor), nunca el texto. */}
          <h1 className="text-2xl font-semibold text-[var(--foreground)]">{title}</h1>
          {count != null && count !== false && <SectionCounter tone={countTone}>{count}</SectionCounter>}
        </div>
        {subtitle && <p className="text-sm text-[var(--muted-foreground)]">{subtitle}</p>}
      </div>
      {children && (
        <div className={`flex gap-2 ${actionsClassName}`}>{children}</div>
      )}
    </div>
  );
}
